module.exports = __webpack_public_path__ + "static/media/nosotros01M.246c9580.jpg";